<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onCancel()">
    <div class="dialog-container" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="dialog-header">
        <div class="header-content">
          <h2 class="dialog-title">{{ t('lang.share_select_targets_title') }}</h2>
          <p class="dialog-subtitle">
            {{ t(shareSelectTargetsSubtitleKey, { entity: integrationEntityName }) }}
          </p>
        </div>
        <button class="close-button" (click)="onCancel()">
          <mzic-svg src="assets/icons/mzic-close.svg" />
        </button>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <!-- Select All Toggle -->
        @if (uploadTargets.length > 1) {
          <div class="select-all-section">
            <label class="checkbox-container" (click)="allSelected ? deselectAll() : selectAll()">
              <input type="checkbox" [checked]="allSelected" />
              <span class="checkbox-custom"></span>
              <span class="checkbox-label">{{ t('lang.share_select_all') }}</span>
            </label>
          </div>
        }

        <!-- Targets List -->
        <div class="targets-list">
          @for (target of uploadTargets; track target.target_id) {
            <div
              class="target-item"
              [class.selected]="isSelected(target.target_id)"
              (click)="toggleTarget(target.target_id)">
              <label class="checkbox-container" (click)="$event.stopPropagation()">
                <input 
                  type="checkbox" 
                  [checked]="isSelected(target.target_id)"
                  (change)="toggleTarget(target.target_id)" />
                <span class="checkbox-custom"></span>
              </label>
              <div class="target-info">
                <div class="target-icon">
                  <mzic-svg src="assets/icons/mzic-cloud-upload-outline.svg" />
                </div>
                <div class="target-details">
                  <p class="target-type">{{ formatRevenueType(target) }}</p>
                  <p class="target-status">
                    {{ t(shareTargetUploadKey, { entity: integrationEntityName }) }}
                  </p>
                </div>
              </div>
            </div>
          }
        </div>

        @if (uploadTargets.length === 0) {
          <div class="empty-state">
            <p>{{ t('lang.share_no_upload_targets') }}</p>
          </div>
        }
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        <button
          class="confirm-button"
          [disabled]="!canConfirm || loading"
          (click)="onConfirm()">
          @if (loading) {
            <mzic-spinner></mzic-spinner>
            {{ t('lang.share_sharing') | uppercase }}
          } @else {
            {{ t('lang.share_share') | uppercase }}
          }
        </button>
        <button class="secondary-button" (click)="onCancel()">
          {{ t('lang.cancel') | uppercase }}
        </button>
      </div>
    </div>
  </div>
</ng-container>

